(function(){
  var CSS=
'#t4s-desc-collection.hw-cd{max-width:900px;margin:0 auto 34px;padding:0;background:transparent;text-align:start;color:#4a4a4a}'+
'.hw-cd__head{position:relative;background:linear-gradient(135deg,#fff 0%,#fff6ee 100%);border:1px solid #efdde6;border-radius:20px;padding:28px 32px 24px;box-shadow:0 8px 26px rgba(93,46,74,.08);margin-bottom:14px}'+
'.hw-cd__head:before{content:"";position:absolute;inset-block-start:0;inset-inline-start:32px;width:60px;height:4px;border-radius:0 0 6px 6px;background:linear-gradient(90deg,#5d2e4a,#ffd8b1)}'+
'.hw-cd h2{margin:6px 0 10px;font-size:25px;line-height:1.5;font-weight:800;color:#5d2e4a;text-align:start}'+
'.hw-cd__head p{margin:0 0 8px;font-size:15.5px;line-height:2;color:#555;text-align:start}'+
'.hw-cd__head p:last-child{margin-bottom:0}'+
'.hw-cd__list{display:flex;flex-direction:column;gap:10px}'+
'.hw-cd__acc{background:#fff;border:1px solid #efdde6;border-radius:16px;overflow:hidden;transition:box-shadow .2s,border-color .2s}'+
'.hw-cd__acc[open]{border-color:#d9b9c9;box-shadow:0 6px 20px rgba(93,46,74,.08)}'+
'.hw-cd__acc>summary{list-style:none;cursor:pointer;display:flex;align-items:center;gap:12px;padding:16px 20px;font-size:16.5px;font-weight:800;color:#551c34;line-height:1.5;text-align:start;user-select:none}'+
'.hw-cd__acc>summary::-webkit-details-marker{display:none}'+
'.hw-cd__acc>summary:before{content:"";flex:none;width:6px;height:22px;border-radius:4px;background:linear-gradient(180deg,#5d2e4a,#ffd8b1)}'+
'.hw-cd__acc>summary:after{content:"";flex:none;margin-inline-start:auto;width:10px;height:10px;border-inline-end:2.4px solid #5d2e4a;border-block-end:2.4px solid #5d2e4a;transform:rotate(45deg);transition:transform .25s;margin-block-end:3px}'+
'.hw-cd__acc[open]>summary:after{transform:rotate(-135deg);margin-block-end:-3px}'+
'.hw-cd__acc>summary:hover{background:#fdf6f9}'+
'.hw-cd__body{padding:2px 22px 20px;text-align:start}'+
'.hw-cd__body ul{list-style:none;margin:0;padding:0}'+
'.hw-cd__body li{position:relative;margin:0 0 10px;padding-inline-start:31px;font-size:14.5px;line-height:1.85;color:#444;text-align:start}'+
'.hw-cd__body li:last-child{margin-bottom:0}'+
'.hw-cd__body li:before{content:"";position:absolute;inset-inline-start:0;top:5px;width:20px;height:20px;border-radius:50%;background:#ffd8b1 url("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27%235d2e4a%27 stroke-width=%273.2%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3E%3Cpath d=%27M5 12.5l4.5 4.5L19 7.5%27/%3E%3C/svg%3E") center/12px no-repeat}'+
'.hw-cd__body p{margin:0 0 8px;font-size:14.5px;line-height:1.95;color:#444;text-align:start}'+
'.hw-cd__body p:last-child{margin-bottom:0}'+
'.hw-cd hr{display:none}'+
'@media(max-width:767px){.hw-cd__head{padding:22px 18px 18px}.hw-cd h2{font-size:20px}.hw-cd__head p{font-size:14.5px}.hw-cd__acc>summary{padding:14px 16px;font-size:15.5px}.hw-cd__body{padding:2px 16px 16px}}';
  function build(){
    var box=document.getElementById('t4s-desc-collection');
    if(!box||box.getAttribute('data-hw-cd'))return;
    if(!document.getElementById('hw-cd-css')){var st=document.createElement('style');st.id='hw-cd-css';st.textContent=CSS;document.head.appendChild(st);}
    box.setAttribute('data-hw-cd','1');box.classList.add('hw-cd');
    var kids=[].slice.call(box.childNodes);
    var head=document.createElement('div');head.className='hw-cd__head';
    var list=document.createElement('div');list.className='hw-cd__list';
    var body=null;
    kids.forEach(function(n){
      if(n.nodeType===3){if(!n.textContent.trim())return;var p=document.createElement('p');p.textContent=n.textContent.trim();n=p;}
      if(n.nodeType!==1)return;
      var tg=n.tagName;
      if(tg==='HR')return;
      if(tg==='H3'||tg==='H4'){
        var d=document.createElement('details');d.className='hw-cd__acc';
        var s=document.createElement('summary');
        s.textContent=n.textContent.replace(/^[\s●•\-–]+/,'').trim();s.setAttribute('dir','auto');
        body=document.createElement('div');body.className='hw-cd__body';
        d.appendChild(s);d.appendChild(body);list.appendChild(d);return;
      }
      if(tg==='SPAN'||tg==='STRONG'||tg==='A'){var q=document.createElement('p');q.appendChild(n);n=q;}
      (body||head).appendChild(n);
    });
    box.innerHTML='';
    if(head.childNodes.length)box.appendChild(head);
    [].slice.call(box.querySelectorAll('h2,p,li')).forEach(function(e){e.setAttribute('dir','auto');});
    [].slice.call(list.querySelectorAll('p,li')).forEach(function(e){e.setAttribute('dir','auto');});
    [].slice.call(head.querySelectorAll('h2,p')).forEach(function(e){e.setAttribute('dir','auto');});
    if(list.children.length){
      box.appendChild(list);
      list.firstElementChild.setAttribute('open','');
    }
  }
  if(document.readyState!=='loading')build();else document.addEventListener('DOMContentLoaded',build);
})();
